<script>
import api from "@/axios";
import Loader from "../components/loader";
import Layout from '../../layouts/main';
import PageHeader from '@/components/page-header';
import appConfig from "@/app.config";
import Swal from "sweetalert2";
import { Vue3Lottie } from 'vue3-lottie';
import 'vue3-lottie/dist/style.css';
import animationJson from '@/assets/animations/monitoramento_anim.json';
import exportFromJSON from "export-from-json";
import moment from "moment/moment";
import { Workbook } from "exceljs";
import { exportDataGrid } from "devextreme/excel_exporter";
import { saveAs } from "file-saver-es";
import {
  DxColumn, DxColumnChooser, DxColumnFixing,
  DxDataGrid, DxExport,
  DxFilterRow, DxGrouping, DxGroupPanel,
  DxPager, DxRemoteOperations, DxStateStoring
} from "devextreme-vue/data-grid";
import DxButton from "devextreme-vue/button";
import DxToolbar, { DxItem } from "devextreme-vue/toolbar";
import { getBaseUrl } from "@/helpers/baseUrl";

const STATUS_MAP = {
  'FA': 'Faturado (FA)',
  'EL': 'Em Elaboração (EL)',
  'AB': 'Em Aberto (AB)',
  'CP': 'Conf. Parcial (CP)',
  'CO': 'Confirmado (CO)',
  'CA': 'Cancelado (CA)',
  'SC': 'Solicitação cancelamento (SC)',
  'CEM': 'CT-e Emitido (CEM)',
  'CAN': 'CT-e Cancelado (CAN)',
  'COL': 'CT-e Conciliado (COL)',
};

const ENDPOINTS = {
  'COTA': 'relatcotafrt',
  'CTE': 'relatmovcte',
  'MOV': 'relatmov',
};

export default {
  page: {
    title: "Relatórios de Fretes",
    meta: [{ name: "description", content: appConfig.description }],
  },

  components: {
    DxColumnFixing, DxStateStoring, DxGrouping, DxToolbar,
    DxItem, DxGroupPanel, DxColumn, DxDataGrid, DxExport, DxRemoteOperations,
    DxPager, DxFilterRow, DxButton, DxColumnChooser, Layout, PageHeader, Loader, Vue3Lottie,
  },

  data() {
    return {
      animationJson,
      title: 'Relatórios de Fretes',
      items: [
        { text: 'Fretes', href: '/' },
        { text: 'Relatórios', active: true },
      ],
      loadingList: true,
      freteList: [],
      updating: false,
      periodo: null,
      periodoPesq: false,
      statusFilter: 'T',
      submittedPeriodo: false,
      dtIniFiltro: null,
      dtFimFiltro: null,
      relatselected: 'COTA',
    };
  },

  computed: {
    dataGrid() {
      return this.$refs.dataGridRefKey.instance;
    },
  },

  mounted() {
    const now = new Date();
    this.periodo = moment(now).format('YYYY-MM');
    this.atualizaDataList();
  },

  methods: {
    confirmarPeriodo() {
      const filtros = JSON.parse(localStorage.getItem('filtros')) || {};
      filtros.movdi = moment(this.dtIniFiltro).format('YYYY-MM-DD');
      filtros.movdf = moment(this.dtFimFiltro).format('YYYY-MM-DD');
      localStorage.setItem('filtros', JSON.stringify(filtros));
      this.atualizaDataList();
    },

    async atualizaDataList() {
      const filtros = JSON.parse(localStorage.getItem('filtros'));

      if (!filtros) {
        this.dtIniFiltro = moment().add(-15, 'days').format('YYYY-MM-DD');
        this.dtFimFiltro = moment().format('YYYY-MM-DD');
        localStorage.setItem('filtros', JSON.stringify({
          movdi: this.dtIniFiltro,
          movdf: this.dtFimFiltro,
        }));
      } else {
        this.dtIniFiltro = filtros.movdi;
        this.dtFimFiltro = filtros.movdf;
        this.periodoPesq = filtros.tipoFilter || false;
      }

      if (!this.dtIniFiltro && !this.dtFimFiltro) {
        this.dtIniFiltro = moment().add(-30, 'days').startOf('month').format('YYYY-MM-DD');
        this.dtFimFiltro = moment().format('YYYY-MM-DD');
      }

      const endpoint = ENDPOINTS[this.relatselected] || 'relatmov';

      this.loadingList = true;
      try {
        const res = await api.get(`${getBaseUrl()}api/${endpoint}`, {
          params: {
            tp: this.periodoPesq,
            s: this.statusFilter,
            di: this.dtIniFiltro,
            df: this.dtFimFiltro,
            fm: this.periodo,
          },
        });
        this.freteList = res.data;
      } catch (error) {
        console.error('Erro ao carregar relatório:', error);
        Swal.fire('Erro', 'Falha ao carregar o relatório.', 'error');
      } finally {
        this.loadingList = false;
      }
    },

    carregouGrid() {
      // Callback chamado quando o grid termina de carregar
    },

    async downloadBlob(endpoint, payload, filename) {
      this.loadingList = true;
      try {
        const res = await api.post(`${getBaseUrl()}api/${endpoint}`, payload, { responseType: 'blob' });
        const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        link.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error(`Erro ao baixar ${filename}:`, error);
        Swal.fire('Erro', `Falha ao gerar o relatório ${filename}.`, 'error');
      } finally {
        this.loadingList = false;
      }
    },

    relatorioCustos() {
      this.downloadBlob('relatcustos', {
        di: this.dtIniFiltro,
        df: this.dtFimFiltro,
      }, 'relatorio-custos.xlsx');
    },

    relatorioApuracao() {
      this.downloadBlob('relatapuracao', {
        ids: this.freteList.map(item => item.id),
      }, 'relatorio-apuracao.xlsx');
    },

    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('plan1');
      exportDataGrid({ component: e.component, worksheet }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${this.title}.xlsx`);
        });
      });
      e.cancel = true;
    },

    refeFormTable() {
      this.dataGrid.state(null);
    },

    nomeStatus(e) {
      return STATUS_MAP[e.value] || 'Não Definido';
    },

    relEFDFiscal() {
      this.updating = true;
      api.get(`${getBaseUrl()}api/efdfisc`, {
        params: { periodo: this.periodo },
      }).then((res) => {
        this.empresaData = res.data[0];
        const data = res.data[1];
        const fileName = `EFD_Fiscal_${this.empresaData.fantasia}_${this.periodo}`;
        const exportType = exportFromJSON.types.txt;
        if (data) exportFromJSON({ data, fileName, exportType });
      }).finally(() => {
        this.updating = false;
      });
    },

    relEFDPisCofins() {
      this.updating = true;
      api.get(`${getBaseUrl()}api/efdpiscof`).then((res) => {
        this.empresaData = res.data[0];
        const data = res.data;
        const fileName = `EFD_PisCofins_${this.empresaData.fantasia}_${this.periodo}`;
        const exportType = exportFromJSON.types.txt;
        if (data) exportFromJSON({ data, fileName, exportType });
      }).finally(() => {
        this.updating = false;
      });
    },

    relResultados() {
      this.updating = true;
      api.get(`${getBaseUrl()}api/relresults`, {
        responseType: 'blob',
      }).then((res) => {
        const fileURL = window.URL.createObjectURL(new Blob([res.data]));
        const fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'Relatorio_resultados_001.pdf');
        document.body.appendChild(fileLink);
        fileLink.click();
      }).finally(() => {
        this.updating = false;
      });
    },

    confirmaPeriodoPesq() {
      localStorage.setItem('filtros', JSON.stringify({
        tipoFilter: this.periodoPesq,
      }));
    },

    mudouPeriodo() {
      // Chamado quando o input de mês muda
    },

    formatDecimal(value) {
      const val = parseFloat(value) || 0;
      return val.toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 4 });
    },

    formatDateTime(value) {
      if (!value) return '-';
      return moment(value).format('DD/MM/YYYY HH:mm:ss');
    },
  },
};
</script>

<template>
  <Layout>
    <span class="float-end" style="z-index: 1; position: absolute; top: 10px; right: 140px; pointer-events: none;">
      <Vue3Lottie :animationData="animationJson" :height="250" :width="250" />
    </span>

    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">

            <!-- Filters Section -->
            <div class="row align-items-end g-3" v-if="!updating">
              <div class="col-lg-2">
                <h5 class="text-muted mb-2">Período do Relatório</h5>
                <select id="selectStatus" v-model="statusFilter" @change="atualizaDataList" class="form-select">
                  <option value="T">Todos Status</option>
                  <option value="A">Ativos</option>
                  <option value="I">Inativos</option>
                </select>
              </div>

              <div class="col-lg-2">
                <label class="form-label">Tipo do Filtro</label>
                <div class="d-flex align-items-center">
                  <b-form-checkbox id="periodoPesq" switch size="md" v-model="periodoPesq" @change="confirmaPeriodoPesq">
                    {{ periodoPesq ? 'Por Período' : 'Por Mês' }}
                  </b-form-checkbox>
                </div>
              </div>

              <div class="col-lg-2" v-if="!periodoPesq">
                <label for="periodo" class="form-label">Filtro Mensal</label>
                <input id="periodo" v-model="periodo" type="month" @change="mudouPeriodo" class="form-control" />
              </div>

              <template v-else>
                <div class="col-lg-2">
                  <label for="dtIniFiltro" class="form-label">Dt. Início</label>
                  <input id="dtIniFiltro" v-model="dtIniFiltro" type="date" class="form-control"
                    :class="{'is-invalid': submittedPeriodo && !dtIniFiltro}" />
                </div>
                <div class="col-lg-2">
                  <label for="dtFimFiltro" class="form-label">Dt. Final</label>
                  <input id="dtFimFiltro" v-model="dtFimFiltro" type="date" class="form-control"
                    :class="{'is-invalid': submittedPeriodo && !dtFimFiltro}" />
                </div>
              </template>

              <div class="col-lg-2">
                <label class="form-label">Tipo Relatório</label>
                <select class="form-select text-primary" v-model="relatselected">
                  <option value="COTA">Cotação</option>
                  <option value="CTE">Cte's</option>
                  <option value="MOV">Notas</option>
                </select>
              </div>

              <div class="col-lg-2 text-end">
                <b-button variant="primary" @click="confirmarPeriodo" class="w-100 mb-0">
                  <i class="bx bx-search me-1"></i> Pesquisar
                </b-button>
              </div>
            </div>

            <!-- Action Buttons Section -->
            <div class="row mt-3" v-if="freteList.length > 0 && !updating">
              <div class="col-1 d-flex gap-2 justify-content-end">
                <b-button variant="primary" v-if="relatselected === 'CTE'" class="btn btn-soft-success" @click="relatorioApuracao">
                  <i class="bx bx-file me-1"></i> Relatório de Apuração
                </b-button>
                <b-button variant="primary" v-if="relatselected === 'MOV'" class="btn btn-soft-success" @click="relatorioCustos">
                  <i class="bx bx-dollar me-1"></i> Relatório de Custos
                </b-button>
              </div>
            </div>

            <div class="table-responsive mt-2">
              <Loader v-if="loadingList" style="min-height: 300px;">
              </Loader>

              <div class="mt-4">
                <DxToolbar>
                  <DxItem location="before" widget="dxButton">
                    <DxButton
                        icon="refresh"
                        hint="Redefinir formatação de tabela para padrão"
                        :on-click="refeFormTable"
                    />
                  </DxItem>
                </DxToolbar>
              </div>

              <div class="mt-0" v-if="!updating">
                <DxDataGrid
                    ref="dataGridRefKey"
                    :data-source="freteList"
                    :show-borders="true"
                    :focused-row-enabled="true"
                    :keyExpr="'id'"
                    :column-auto-width="true"
                    :show-row-lines="true"
                    :allow-column-reordering="true"
                    :allow-column-resizing="true"
                    :row-alternation-enabled="true"
                    @content-ready="carregouGrid"
                    @exporting="onExporting"
                >
                  <DxRemoteOperations
                      :filtering="true"
                      :paging="true"
                      :sorting="true"
                      :summary="true"
                      :grouping="false"
                      :group-paging="false"
                  />

                  <DxColumnChooser :enabled="true" />
                  <DxColumnFixing :enabled="true" />
                  <DxFilterRow :visible="false" />

                  <!--<DxSelection mode="multiple" />-->

                  <DxExport
                      :enabled="true"
                      :allow-export-selected-data="true"
                  />
                  <DxStateStoring
                      :enabled="true"
                      type="sessionStorage"
                      storage-key="strWmsOsEntradaList"
                  />

                  <DxGroupPanel :visible="false" />
                  <DxGrouping />


                  <DxColumn
                      :width="60"
                      data-field="id"
                      caption="ID"
                      sort-order="desc"
                      data-type="number"
                      alignment="right"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      data-field="codigo"
                      caption="Código"
                      data-type="text"
                      alignment="right"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'COTA'"
                      :width="180"
                      data-field="empresa_model.nome"
                      caption="Empresa Nome"
                      data-type="text"
                      alignment="left"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'COTA'"
                      data-field="empresa_model.cnpj"
                      caption="Empresa Cnpj"
                      data-type="text"
                      alignment="right"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'COTA'"
                      data-field="tipo"
                      caption="Tipo"
                      data-type="text"
                      alignment="left"
                      :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                      :allow-sorting="false"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'COTA'"
                      :width="180"
                      data-field="nome"
                      caption="Cliente"
                      data-type="text"
                      alignment="left"
                      :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                      :allow-sorting="false"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'COTA'"
                      data-field="cnpj"
                      caption="Cliente Cnpj"
                      data-type="text"
                      alignment="right"
                      :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                      :allow-sorting="false"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      data-field="status"
                      caption="Status"
                      data-type="text"
                      alignment="center"
                      :customize-text="nomeStatus"
                      :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                      :allow-sorting="false"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'CTE'"
                      data-field="cfop"
                      caption="CFOP"
                      data-type="text"
                      alignment="right"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'CTE'"
                      data-field="natopv"
                      caption="Natureza"
                      data-type="text"
                      alignment="right"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'MOV'"
                      data-field="natop"
                      caption="Natureza"
                      data-type="text"
                      alignment="right"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'COTA'"
                      data-field="segto"
                      caption="Seguimento"
                      data-type="text"
                      alignment="right"
                      :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                      :allow-sorting="false"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'COTA'"
                      data-field="cepori"
                      caption="CEP Origem"
                      data-type="text"
                      alignment="right"
                      :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                      :allow-sorting="false"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'COTA'"
                      data-field="logrori"
                      caption="Logr. Origem"
                      data-type="text"
                      alignment="left"
                      :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                      :allow-sorting="false"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'COTA'"
                      data-field="nroori"
                      caption="Nro. Origem"
                      data-type="text"
                      alignment="right"
                      :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                      :allow-sorting="false"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'COTA'"
                      data-field="complori"
                      caption="Compl. Origem"
                      data-type="text"
                      alignment="left"
                      :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                      :allow-sorting="false"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'COTA'"
                      data-field="bairroori"
                      caption="Bairro Origem"
                      data-type="text"
                      alignment="left"
                      :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                      :allow-sorting="false"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'COTA'"
                      data-field="cidori"
                      caption="Cidade Origem"
                      data-type="text"
                      alignment="left"
                      :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                      :allow-sorting="false"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'COTA'"
                      data-field="ufori"
                      caption="UF Origem"
                      data-type="text"
                      alignment="left"
                      :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                      :allow-sorting="false"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'COTA'"
                      data-field="cepdest"
                      caption="CEP Dest"
                      data-type="text"
                      alignment="right"
                      :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                      :allow-sorting="false"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'COTA'"
                      data-field="logrdest"
                      caption="Logr. Dest"
                      data-type="text"
                      alignment="left"
                      :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                      :allow-sorting="false"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'COTA'"
                      data-field="nrodest"
                      caption="Nro. Dest"
                      data-type="text"
                      alignment="right"
                      :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                      :allow-sorting="false"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'COTA'"
                      data-field="compldest"
                      caption="Compl. Dest"
                      data-type="text"
                      alignment="left"
                      :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                      :allow-sorting="false"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'COTA'"
                      data-field="bairrodest"
                      caption="Bairro Dest"
                      data-type="text"
                      alignment="left"
                      :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                      :allow-sorting="false"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'COTA'"
                      data-field="ciddest"
                      caption="Cidade Dest"
                      data-type="text"
                      alignment="left"
                      :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                      :allow-sorting="false"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'COTA'"
                      data-field="ufdest"
                      caption="UF Dest"
                      data-type="text"
                      alignment="left"
                      :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                      :allow-sorting="false"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'COTA'"
                      data-field="cotaid"
                      caption="Cota ID"
                      data-type="text"
                      alignment="right"
                      :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                      :allow-sorting="false"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'COTA'"
                      data-field="dtcoleta"
                      caption="Dt. Coleta"
                      alignment="right"
                      :format="formatDateTime"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'COTA' || relatselected === 'MOV'"
                      data-field="nometransp"
                      caption="Transp. Nome"
                      data-type="text"
                      alignment="left"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'CTE'"
                      data-field="emitnome"
                      caption="Emit. Nome"
                      data-type="text"
                      alignment="left"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'COTA'"
                      data-field="cnpjtransp"
                      caption="Transp. Cnpj"
                      data-type="text"
                      alignment="right"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'MOV'"
                      data-field="transpcnpj"
                      caption="Transp. Cnpj"
                      data-type="text"
                      alignment="right"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'CTE'"
                      data-field="emitcnpj"
                      caption="Emit. CNPJ"
                      data-type="text"
                      alignment="right"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'CTE'"
                      data-field="emitcidade"
                      caption="Emit. Cidade"
                      data-type="text"
                      alignment="left"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'MOV'"
                      data-field="transp cidade"
                      caption="Transp. Cidade"
                      data-type="text"
                      alignment="left"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'CTE'"
                      data-field="emitestado"
                      caption="Emit. Estado"
                      data-type="text"
                      alignment="left"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'MOV'"
                      data-field="transpestado"
                      caption="Transp. Estado"
                      data-type="text"
                      alignment="left"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'CTE' || relatselected === 'MOV'"
                      data-field="remetnome"
                      caption="Remet. Nome"
                      data-type="text"
                      alignment="left"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'CTE' || relatselected === 'MOV'"
                      data-field="remetcnpj"
                      caption="Remet. CNPJ"
                      data-type="text"
                      alignment="right"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'CTE' || relatselected === 'MOV'"
                      data-field="remetcidade"
                      caption="Remet. Cidade"
                      data-type="text"
                      alignment="left"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'CTE' || relatselected === 'MOV'"
                      data-field="remetestado"
                      caption="Remet. Estado"
                      data-type="text"
                      alignment="left"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'CTE' || relatselected === 'MOV'"
                      data-field="destnome"
                      caption="Dest. Nome"
                      data-type="text"
                      alignment="left"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'CTE' || relatselected === 'MOV'"
                      data-field="destcnpj"
                      caption="Dest. CNPJ"
                      data-type="text"
                      alignment="right"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'CTE' || relatselected === 'MOV'"
                      data-field="destcidade"
                      caption="Dest. Cidade"
                      data-type="text"
                      alignment="left"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'CTE' || relatselected === 'MOV'"
                      data-field="destestado"
                      caption="Dest. Estado"
                      data-type="text"
                      alignment="left"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'CTE'"
                      data-field="recebrua"
                      caption="Receb. Rua"
                      data-type="text"
                      alignment="left"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'CTE'"
                      data-field="recebnum"
                      caption="Receb. Nro"
                      data-type="text"
                      alignment="right"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'CTE'"
                      data-field="recebcompl"
                      caption="Receb. Compl"
                      data-type="text"
                      alignment="left"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'CTE'"
                      data-field="recebcidade"
                      caption="Receb. Cidade"
                      data-type="text"
                      alignment="left"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'CTE'"
                      data-field="recebestado"
                      caption="Receb. Estado"
                      data-type="text"
                      alignment="left"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'CTE'"
                      data-field="recebcep"
                      caption="Receb. CEP"
                      data-type="text"
                      alignment="right"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'CTE'"
                      data-field="tomador"
                      caption="Tomador"
                      data-type="text"
                      alignment="left"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'COTA'"
                      :width="180"
                      data-field="obscoleta"
                      caption="Obs Coleta"
                      data-type="text"
                      alignment="left"
                      :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                      :allow-sorting="false"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'CTE' || relatselected === 'MOV'"
                      :width="180"
                      data-field="obs"
                      caption="Obs"
                      data-type="text"
                      alignment="left"
                      :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                      :allow-sorting="false"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'CTE'"
                      data-field="mod"
                      caption="Mod"
                      data-type="text"
                      alignment="right"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'MOV'"
                      data-field="numnf"
                      caption="NFe"
                      data-type="text"
                      alignment="right"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'CTE' || relatselected === 'MOV'"
                      data-field="serie"
                      caption="Serie"
                      data-type="text"
                      alignment="right"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'CTE' || relatselected === 'MOV'"
                      data-field="chave"
                      caption="Chave"
                      data-type="text"
                      alignment="right"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'CTE'"
                      data-field="numero"
                      caption="Numero"
                      data-type="text"
                      alignment="right"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'CTE' || relatselected === 'MOV'"
                      :width="150"
                      data-field="dtemissao"
                      caption="Dt. Emissão"
                      alignment="right"
                      :format="formatDateTime"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if=" relatselected === 'CTE' || relatselected === 'MOV'"
                      :width="150"
                      data-field="dtpreventr"
                      caption="Dt. Preventr"
                      alignment="right"
                      :format="formatDateTime"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'CTE' || relatselected === 'MOV'"
                      :width="150"
                      data-field="dtentrega"
                      caption="Dt. Entrega"
                      alignment="right"
                      :format="formatDateTime"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'MOV'"
                      :width="150"
                      data-field="dtemitcte"
                      caption="Dt. EmitCte"
                      alignment="right"
                      :format="formatDateTime"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'MOV'"
                      data-field="pesocte"
                      caption="Peso CTe (Kg)"
                      alignment="right"
                      :format="formatDecimal"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'MOV'"
                      data-field="valorcte"
                      caption="Vlr CTe (R$)"
                      alignment="right"
                      :format="formatDecimal"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'CTE'"
                      data-field="valor"
                      caption="Valor (R$)"
                      alignment="right"
                      :format="formatDecimal"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      :data-field="relatselected === 'COTA' ? 'valornf' : relatselected === 'CTE' ? 'valorcarga': 'valorprd'"
                      caption="Vlr Produto (R$)"
                      alignment="right"
                      :format="formatDecimal"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'MOV'"
                      data-field="valorliq"
                      caption="Vlr Liq. (R$)"
                      alignment="right"
                      :format="formatDecimal"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'MOV'"
                      data-field="valorbrt"
                      caption="Vlr Bruto (R$)"
                      alignment="right"
                      :format="formatDecimal"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      data-field="valorfrete"
                      caption="Vlr Frete (R$)"
                      alignment="right"
                      :format="formatDecimal"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'CTE'"
                      data-field="icmsvalor"
                      caption="ICMS Vlr"
                      alignment="right"
                      :format="formatDecimal"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      data-field="peso"
                      caption="Peso (Kg)"
                      alignment="right"
                      :format="formatDecimal"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'MOV'"
                      data-field="pesobrt"
                      caption="Vlr Bruto (Kg)"
                      alignment="right"
                      :format="formatDecimal"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'CTE'"
                      data-field="pesomaior"
                      caption="Peso Maior (Kg)"
                      alignment="right"
                      :format="formatDecimal"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'CTE'"
                      data-field="pesoreal"
                      caption="Peso Real (Kg)"
                      alignment="right"
                      :format="formatDecimal"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      data-field="qtdvol"
                      caption="Qtd. Volume"
                      data-type="text"
                      alignment="right"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'CTE'"
                      data-field="prazomincota"
                      caption="Menor Prazo Cotado"
                      data-type="text"
                      alignment="right"
                      :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                      :allow-sorting="false"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'CTE'"
                      data-field="valorprazmin"
                      caption="Vlr Menor Prazo"
                      alignment="right"
                      :format="formatDecimal"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'CTE'"
                      data-field="valormincota"
                      caption="Menor Vlr Cotado"
                      alignment="right"
                      :format="formatDecimal"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'CTE'"
                      data-field="prazovalmin"
                      caption="Prazo Menor Vlr"
                      data-type="text"
                      alignment="right"
                      :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                      :allow-sorting="false"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'COTA'"
                      data-field="pesofrete"
                      caption="Peso (Kg)"
                      alignment="right"
                      :format="formatDecimal"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'COTA'"
                      data-field="percfrete"
                      caption="Perc Frete (%)"
                      alignment="right"
                      :format="formatDecimal"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'COTA' || relatselected === 'MOV'"
                      data-field="prazo"
                      caption="Prazo"
                      data-type="text"
                      alignment="right"
                      :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                      :allow-sorting="false"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'COTA'"
                      data-field="altura"
                      caption="Altura"
                      alignment="right"
                      :format="formatDecimal"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'COTA'"
                      data-field="largura"
                      caption="largura"
                      alignment="right"
                      :format="formatDecimal"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'COTA'"
                      data-field="comprim"
                      caption="Comprimento (R$)"
                      alignment="right"
                      :format="formatDecimal"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'COTA'"
                      data-field="dimens"
                      caption="Dimensão"
                      alignment="right"
                      :format="formatDecimal"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'CTE'"
                      data-field="cubagem"
                      caption="Cubagem"
                      alignment="right"
                      :format="formatDecimal"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'CTE'"
                      data-field="cubdesc"
                      caption="Cub. Descrição"
                      data-type="text"
                      alignment="right"
                      :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                      :allow-sorting="false"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'MOV'"
                      data-field="wmsos_id"
                      caption="WmsOS ID"
                      data-type="text"
                      alignment="right"
                      :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                      :allow-sorting="false"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      v-if="relatselected === 'MOV'"
                      data-field="wmsromaneio_id"
                      caption="Romaneio ID"
                      data-type="text"
                      alignment="right"
                      :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                      :allow-sorting="false"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      data-field="created_by"
                      caption="Criador"
                      data-type="text"
                      alignment="left"
                      :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                      :allow-sorting="false"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      :width="150"
                      data-field="created_at"
                      caption="Dt. Criação"
                      alignment="right"
                      :format="formatDateTime"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxPager
                      :visible="true"
                      :show-page-size-selector="true"
                      :allowed-page-sizes="[10, 30, 50, 100]"
                      :show-navigation-buttons="true"
                      :show-info="true"
                  />
                </DxDataGrid>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </Layout>
</template>

